import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {}

  get<T>(endpoint: string): Observable<T> {
    return this.http
      .get<T>(`${this.baseUrl}/${endpoint}`)
      .pipe(catchError(this.handleError));
  }

  post<T>(
    endpoint: string,
    body: any,
    options?: { headers?: HttpHeaders }
  ): Observable<T> {
    const headers =
      options?.headers ||
      (body instanceof FormData
        ? undefined
        : new HttpHeaders({ 'Content-Type': 'application/json' }));
    return this.http
      .post<T>(`${this.baseUrl}/${endpoint}`, body, { headers })
      .pipe(catchError(this.handleError));
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http
      .put<T>(`${this.baseUrl}/${endpoint}`, body)
      .pipe(catchError(this.handleError));
  }

  delete<T>(endpoint: string, id: number): Observable<T> {
    return this.http
      .delete<T>(`${this.baseUrl}/${endpoint}/${id}`)
      .pipe(catchError(this.handleError));
  }

  postId<T>(endpoint: string, body: any, options?: { headers?: HttpHeaders }): Observable<T> {
    const headers =
    options?.headers ||
    (body instanceof FormData
      ? undefined
      : new HttpHeaders({ 'Content-Type': 'application/json' }));

    return this.http
      .post<T>(`${this.baseUrl}/${endpoint}`,'', { headers })
      .pipe(catchError(this.handleError));
  }

private handleError(error: any): Observable<never> {
  console.error(`Erro ${error.status}:`, error.message);
  return throwError(() => error);
}
}
